<div
  class="cads-main-template-modal__sheet"
  [class.cads-main-template-modal__sheet--mobile]="sheetClass()"
  role="presentation"
  (click)="_onBackdropClick($event)"
>
  <div
    #dialogPanel
    class="cads-main-template-modal__panel"
    [class.cads-main-template-modal__panel--fixed-height]="panelFixedHeight()"
    [ngClass]="sizeClass()"
    [style.height]="panelStyles()?.height ?? null"
    [style.max-height]="panelStyles()?.['max-height'] ?? null"
    role="dialog"
    aria-modal="true"
    tabindex="-1"
    [attr.aria-label]="accessibleLabel()"
    (keydown.escape)="_onEscape($event)"
    (click)="$event.stopPropagation()"
  >
    @if (showCloseButton()) {
      <button
        type="button"
        class="cads-main-template-modal__close"
        aria-label="Close"
        (click)="_onCloseClick()"
      >
        <cads-icon-view-bit [config]="closeIconConfig" />
      </button>
    }

    <div class="cads-main-template-modal__content">
      <cads-main-template
        [config]="templateConfig()"
        (secondaryTapped)="_onSecondaryTap()"
        (primaryTapped)="_onPrimaryTap()"
      >
        <ng-container ngProjectAs="[cads-main-header]">
          <ng-content select="[cads-main-header]" />
        </ng-container>
        <ng-container ngProjectAs="[cads-main-hero]">
          <ng-content select="[cads-main-hero]" />
        </ng-container>
        <ng-container ngProjectAs="[cads-main-body]">
          <ng-content select="[cads-main-body]" />
        </ng-container>
        <ng-container ngProjectAs="[cads-main-footer]">
          <ng-content select="[cads-main-footer]" />
        </ng-container>
      </cads-main-template>
    </div>
  </div>
</div>
